// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1NbSY","right":"styles_right__1mjhh"};